import React from "react";
import {
    Box,
    Container,
    Grid,
    Typography,
    Stack,
    Paper,
} from "@mui/material";

import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";

import SobreImagem from "../assets/emma.jpeg"; // trocar pela terceira foto do feed

export default function Sobre() {
    const values = [
        {
            icon: <WorkspacePremiumRoundedIcon sx={{ fontSize: 30 }} />,
            title: "Excelência",
            text: "Cuidado na seleção de produtos e na entrega.",
        },
        {
            icon: <ShieldOutlinedIcon sx={{ fontSize: 30 }} />,
            title: "Transparência",
            text: "Segurança total na compra, sigilo de dados e envio discreto.",
        },
        {
            icon: <FavoriteBorderRoundedIcon sx={{ fontSize: 30 }} />,
            title: "Cliente no Centro",
            text: "Políticas de troca bem estabelecidas e atendimento de suporte de fácil acessibilidade.",
        },
    ];

    return (
        <Box sx={{ bgcolor: "#fff", overflowX: "hidden" }}>
            {/* HEADER MAIS LIMPO */}
            <Box
                sx={{
                    pt: { xs: 8, md: 10 },
                    pb: { xs: 6, md: 7 },
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                    background:
                        "linear-gradient(180deg, rgba(0,102,204,0.04) 0%, rgba(255,255,255,1) 100%)",
                }}
            >
                <Container maxWidth="lg">
                    <Stack spacing={2} alignItems="center" textAlign="center">
                        <Typography
                            sx={{
                                color: "var(--azul)",
                                fontWeight: 800,
                                letterSpacing: "0.14em",
                                textTransform: "uppercase",
                                fontSize: "0.82rem",
                            }}
                        >
                            Sobre nós
                        </Typography>

                        <Typography
                            component="h1"
                            sx={{
                                fontWeight: 800,
                                color: "#111",
                                lineHeight: 1.1,
                                letterSpacing: "-0.03em",
                                fontSize: {
                                    xs: "2rem",
                                    sm: "2.5rem",
                                    md: "3.4rem",
                                },
                                maxWidth: 760,
                            }}
                        >
                            Conheça um pouco mais sobre a nossa empresa, valores e propostas
                        </Typography>

                        <Typography
                            sx={{
                                color: "var(--cinza)",
                                fontSize: { xs: "0.98rem", md: "1.05rem" },
                                lineHeight: 1.8,
                                maxWidth: 700,
                            }}
                        >
                            Nosso compromisso está em oferecer uma experiência segura,
                            transparente e confiável em cada etapa da sua compra.
                        </Typography>
                    </Stack>
                </Container>
            </Box>

            {/* CONTEÚDO PRINCIPAL */}
            <Container maxWidth="lg" sx={{ py: { xs: 6, md: 9 } }}>
                <Grid container spacing={{ xs: 4, md: 7 }} alignItems="center">
                    {/* TEXTO */}
                    <Grid item xs={12} md={6}>
                        <Box>
                            <Typography
                                sx={{
                                    color: "var(--azul)",
                                    fontWeight: 800,
                                    letterSpacing: "0.14em",
                                    textTransform: "uppercase",
                                    fontSize: "0.82rem",
                                    mb: 1.5,
                                }}
                            >
                                Quem somos
                            </Typography>

                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    color: "#111",
                                    lineHeight: 1.15,
                                    fontSize: {
                                        xs: "1.8rem",
                                        sm: "2.2rem",
                                        md: "2.8rem",
                                    },
                                    mb: 3,
                                }}
                            >
                                Nossa transparência e compromisso com o que fazemos
                            </Typography>

                            <Stack spacing={2.4}>
                                <Typography
                                    sx={{
                                        color: "var(--cinza)",
                                        lineHeight: 1.9,
                                        fontSize: { xs: "0.98rem", md: "1rem" },
                                    }}
                                >
                                    Nossa loja tem o objetivo de oferecer produtos originais e de
                                    alta qualidade, para auxiliar a isso temos esse site de compra
                                    simples e atendimento personalizado no WhatsApp, priorizamos a
                                    transparência, segurança e sigilo. Aqui cada detalhe importa
                                    desde do atendimento à entrega.
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "var(--cinza)",
                                        lineHeight: 1.9,
                                        fontSize: { xs: "0.98rem", md: "1rem" },
                                    }}
                                >
                                    Trabalhamos diariamente para selecionar os melhores produtos e
                                    novidades, além de aprimorar os métodos de envio, prezando
                                    pela procedência, confiabilidade e inovação. Nosso foco está
                                    em construir uma relação de confiança e fidelidade duradoura
                                    com cada um de vocês.
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "var(--cinza)",
                                        lineHeight: 1.9,
                                        fontSize: { xs: "0.98rem", md: "1rem" },
                                    }}
                                >
                                    Mais do que vender, buscamos entregar produtos originais de
                                    valor justo, acessibilidade para todo o Brasil, praticidade e
                                    uma experiência positiva em cada interação.
                                </Typography>
                            </Stack>
                        </Box>
                    </Grid>

                    {/* FOTO — só a imagem, centralizada, sem moldura clara */}
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            component="img"
                            src={SobreImagem}
                            alt="Emma Pods"
                            sx={{
                                display: "block",
                                width: "100%",
                                maxWidth: { xs: 320, sm: 400, md: 480 },
                                height: "auto",
                                objectFit: "contain",
                                objectPosition: "center",
                                mx: "auto",
                                borderRadius: { xs: "16px", md: "20px" },
                                boxShadow: "0 16px 40px rgba(0,0,0,0.14)",
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>

            {/* VALORES */}
            <Box
                sx={{
                    pb: { xs: 7, md: 9 },
                    px: 2,
                }}
            >
                <Container maxWidth="lg">
                    <Box sx={{ textAlign: "center", mb: { xs: 4, md: 5 } }}>
                        <Typography
                            sx={{
                                color: "var(--azul)",
                                fontWeight: 800,
                                letterSpacing: "0.14em",
                                textTransform: "uppercase",
                                fontSize: "0.82rem",
                                mb: 1,
                            }}
                        >
                            Nossos valores
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: 800,
                                color: "#111",
                                fontSize: { xs: "1.7rem", md: "2.3rem" },
                                lineHeight: 1.2,
                            }}
                        >
                            O que guia cada detalhe da nossa loja
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "repeat(2, minmax(0, 1fr))",
                                md: "repeat(3, minmax(0, 1fr))",
                            },
                            gap: 3,
                            width: "100%",
                        }}
                    >
                        {values.map((item, index) => (
                            <Paper
                                key={index}
                                elevation={0}
                                sx={{
                                    width: "100%",
                                    p: { xs: 3, md: 3.5 },
                                    borderRadius: "22px",
                                    border: "1px solid rgba(0,0,0,0.07)",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 12px 30px rgba(0,0,0,0.05)",
                                    transition: "all 0.25s ease",
                                    display: "flex",
                                    flexDirection: "column",
                                    "&:hover": {
                                        transform: "translateY(-4px)",
                                        boxShadow: "0 18px 36px rgba(0,0,0,0.08)",
                                        borderColor: "rgba(0,102,204,0.18)",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: 58,
                                        height: 58,
                                        borderRadius: "16px",
                                        bgcolor: "rgba(0,102,204,0.10)",
                                        color: "var(--azul)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mb: 2.5,
                                        flexShrink: 0,
                                    }}
                                >
                                    {item.icon}
                                </Box>

                                <Typography
                                    sx={{
                                        fontWeight: 800,
                                        color: "#111",
                                        fontSize: "1.15rem",
                                        mb: 1.2,
                                    }}
                                >
                                    {item.title}
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "var(--cinza)",
                                        lineHeight: 1.8,
                                        fontSize: "0.97rem",
                                    }}
                                >
                                    {item.text}
                                </Typography>
                            </Paper>
                        ))}
                    </Box>
                </Container>
            </Box>
        </Box>
    );
}